import * as React from "react";

import "./shipping-addresses-route.scss";

import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";

import {ShippingAddressesPanel} from "../../common/shipping-addresses-panel/shipping-addresses-panel";
import {AddressBookLayout}      from "../common/address-book-layout";

export const ShippingAddressesRoute = ({}) => cs(
    ({}, next) => AddressBookLayout({activeTab: "shipping", next}),
    consumeContext("apis"),
    ({}, next) => (
        <div className="shipping-addresses-route-4dk">
            {next()}
        </div>
    ),
    ({apis}) => ShippingAddressesPanel({
        apis: {
            getList: () => apis.next.shipping.getMyShippingAddresses({infoFor: 'account_resources'}),
            // add: (address) => apis.next.shipping.addShippingAddress({address}), // No need, is default behavior
            deleteShippingAddress: (id) => apis.next.shipping.deleteShippingAddress(id),
        },
    }),
);
